import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getContactRouterLink} from "root/Wieldy/routePaths";
import {getMessagingMenuTypeForUser} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {MessageFilters, MessageMenuTitles} from "root/DataFunctions/Constants";

const ContactMessagingSubmenu = (props ) =>
{
    const globals = useContext(GlobalContext);
    const menuType = getMessagingMenuTypeForUser(globals.userType);

    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Ensure we always have a default message filter
    const message_filter_type = queryParams.type === undefined ? MessageFilters.INCOMING : queryParams.type;

    const managerMessagingSubmenu = () =>
    {
        return (
            <AppSidebarGroup title='Messages' default={message_filter_type}>
                {/*<AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages?type=' + MessageFilters.INCOMING )} title={MessageMenuTitles.INCOMING} iconName='icon-inbox' name={MessageFilters.INCOMING}/>*/}
                {/*<AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages?type=' + MessageFilters.RETURNED )} title='Returned' iconName='icon-queries' name={MessageFilters.RETURNED}  />*/}
                <AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages?type=' + MessageFilters.SENT )} title={MessageMenuTitles.SENT}  iconName='icon-draft' name={MessageFilters.SENT}/>
                <AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages?type=' + MessageFilters.DRAFT )} title={MessageMenuTitles.DRAFT} iconName='icon-edit' name={MessageFilters.DRAFT}/>
                {/*<AppSidebarMenuItem link={getContactRouterLink(props.user_id, 'messages?type=' + MessageFilters.ALL)} title='All' iconName='icon-email' name={MessageFilters.ALL} />*/}
            </AppSidebarGroup>
        )
    }

    const menuSection = (menuType) =>
    {
        return managerMessagingSubmenu() ;
    }

    return (
        <Fragment>
            {menuSection(menuType)}
        </Fragment>
    )
}

export default ContactMessagingSubmenu ;